import { Static, Type } from '@sinclair/typebox';
import { MinimalUser, minimalUserSchema } from '../../shared/user/user.schema';

export const userFollowerSchema = Type.Object({
  id: Type.String({
    description: 'Unique identifier of the user follower for the provider. Usually an internal identifier used by the API only.',
  }),
  object: Type.Literal('UserFollower'),
  user: Type.Object(minimalUserSchema, { description: 'The user following the account owner.' }),
  created_at: Type.Optional(Type.String({ description: 'Date and time when the follow was created. ' })),
});

export type UserFollower<UserSpecifics = unknown> = Omit<Static<typeof userFollowerSchema>, 'user'> & {
  user: MinimalUser<UserSpecifics>;
};
